import { Accordion } from "@sede-x/shell-ds-react-framework";
import { useEffect, useRef } from "react";
import { TTicketSearchCriteria } from "ticketing/ticketing.types";
import { SearchTicketsForm } from "./SearchTicketsForm";

type TSearchTicketsContainerProps = {
  searchCriteria?: TTicketSearchCriteria;
  onSearch: (criteria: TTicketSearchCriteria) => void;
  open: boolean;
  onCollapsed: (collpased: boolean) => void;
  onReset: () => void;
  loading: boolean;
};

export default function SearchTicketsContainer({
  searchCriteria,
  onSearch,
  open,
  onCollapsed,
  onReset,
  loading
}: Readonly<TSearchTicketsContainerProps>) {
  const accordionRef = useRef<HTMLDivElement>(null);
  const prevHeightRef = useRef<number>(0);
  const SIGNIFICANT_HEIGHT_CHANGE_THRESHOLD = 20;

  useEffect(() => {
    if (!accordionRef.current) {
      return () => {};
    }

    const accordionEl = accordionRef.current;
    const resizeObserver = new ResizeObserver(entries => {
      for (const entry of entries) {
        const currentHeight = entry.contentRect.height;
        if (
          Math.abs(currentHeight - prevHeightRef.current) > SIGNIFICANT_HEIGHT_CHANGE_THRESHOLD
        ) {
          const isExpanded = currentHeight > prevHeightRef.current;

          if ((isExpanded && !open) || (!isExpanded && open)) {
            onCollapsed(isExpanded);
          }
          prevHeightRef.current = currentHeight;
        }
      }
    });
    resizeObserver.observe(accordionEl);

    return () => {
      resizeObserver.unobserve(accordionEl);
      resizeObserver.disconnect();
    };
  }, [accordionRef, onCollapsed, open]);

  const defaultActiveKey = open ? "1" : undefined;

  return (
    <div className={"search-wrapper"}>
      <div className={"card-container"}>
        <div ref={accordionRef}>
          <Accordion
            defaultActiveKey={defaultActiveKey}
            iconSet="chevron"
            items={[
              {
                key: 1,
                label: `Search Tickets`,
                children: (
                  <div className="form-container">
                    <SearchTicketsForm
                      searchCriteria={searchCriteria}
                      onSearch={onSearch}
                      onReset={onReset}
                      loading={loading}
                    />
                  </div>
                )
              }
            ]}
            bodyPadding={false}
            fullWidth={true}
          />
        </div>
      </div>
    </div>
  );
}
